import map from 'lodash/map';
import includes from 'lodash/includes';
import replace from 'lodash/replace';

const RequestPermission = (to, from, next) => {
	const userLogin = JSON.parse(window.localStorage.getItem('user_data'));
	const permissions = userLogin.permissions;
	if (!includes(permissions, to.meta.permission)) {
		return next({
			path: '/error'
		});
	}
	return next();
};

const UserHaveRoles = (to, from, next) => {
	const userLogin = JSON.parse(window.localStorage.getItem('user_data'));
	const role = userLogin.roles[0];
	if (to.meta.roles.includes(role.name)) {
		return next();
	}
	return next({
		path: '/error'
	});
};

export { RequestPermission, UserHaveRoles };
//export default RequestPermission;
